// 系统名称
const SYSTEM_NAME = process.env.VUE_APP_SYSTEM_NAME
// 版权申明
const COPYRIGHT = process.env.VUE_APP_COPYRIGHT
// 备案编号
const LICENSE_NUMBER = process.env.VUE_APP_LICENSE_NUMBER

export default {
    // base
    userInfo: null,
    role: null,
    // setting module
    isMobile: false,
    theme: 'light',
    layout: 'side',
    multipage: true,
    fixedHeader: true,
    fixedSidebar: true,
    reviewOperation:{},
    // ------------------------- 系统配置 -------------------------
    // 系统是否初始化完毕
    isInit: false,
    // 系统名称
    systemName: SYSTEM_NAME,
    // 版权申明
    copyright: COPYRIGHT,
    // 备案编号
    licenseNumber: LICENSE_NUMBER,
    loginUrl:'',
    registerUrl:'',
    supervisionUrl:'',
    marginAmountStatistics: '',
    technicalSupport:'',

    // 是否显示投诉举报
    showComplaints:'',
    // 是否显示信用公示
    showCreditPublicity:'',
    // 是否显示企业中心
    showEnterpriseCenter:'',
    // 是否显示办理指南
    showHandlingGuide:'',
    // 是否显示首页
    showIndex:'',
    // 是否显示机构公示
    showOrgPublicity:'',
    // 是否显示政策法规
    showPoliciesRegulations:'',
    // 是否显示监管中心
    showSupervisionCenter:'',
    // 是否显示保单验真
    showPolicyVerification: '',

    // 系统平台名称下的小标题
    domainNameTitle: '',
    // 头部组件新老版本的开关
    version:''
}
